import React, { Component } from 'react';
import { Link } from "react-router-dom";

import { Row } from '@shadcn/components/ui/row'
import { Col } from '@shadcn/components/ui/col'
//Import Cards
import CardMaintenance from "./card-maintenance";

//Import Images
import maintenance from "../../assets/images/maintenance.png";
import logo from "../../assets/images/logo-dark.png";

class PagesMaintenance extends Component {
    render() {
        return (
            <React.Fragment>
                <section className="my-12 pt-12">
                <div className="w-full px-3 mx-auto xl:max-w-[85%]">
                        <Row>
                            <Col xs="12" className="text-center">
                                <div className="home-wrapper">
                                    <div className="mb-5 flex justify-center items-center ">
                                        <img src={logo} alt="logo" className='h-6'/>
                                    </div>

                                    <Row className="justify-content-center">
                                        <Col sm={4} className="sm:w-4/12">
                                            <div className="maintenance-img">
                                                <img src={maintenance} alt="" className="img-fluid mx-auto d-block" />
                                            </div>
                                        </Col>
                                    </Row>
                                    <h3 className="mt-12 text-[23px] text-[#495057]">Site is Under Maintenance</h3>
                                    <p>Please check back in sometime.</p>

                                    <Row className="gap-6 mt-12">
                                        <CardMaintenance>
                                            <i className="bx bx-broadcast mb-4 h1 text-primary"></i>
                                            <h5 className="font-size-15 text-uppercase">Why is the Site Down?</h5>
                                            <p className="text-[#74788d] mb-0">There are many variations of passages of
                                                Lorem Ipsum available, but the majority have suffered alteration.</p>
                                        </CardMaintenance>

                                        <CardMaintenance>
                                            <i className="bx bx-time-five mb-4 h1 text-primary"></i>
                                            <h5 className="font-size-15 text-uppercase">
                                                What is the Downtime?</h5>
                                            <p className="text-[#74788d] mb-0">Contrary to popular belief, Lorem Ipsum is not
                                                simply random text. It has roots in a piece of classNameical.</p>
                                        </CardMaintenance>

                                        <CardMaintenance>
                                            <i className="bx bx-envelope mb-4 h1 text-primary"></i>
                                            <h5 className="font-size-15 text-uppercase">
                                                Do you need Support?</h5>
                                            <p className="text-[#74788d] mb-0">If you are going to use a passage of Lorem
                                            Ipsum, you need to be sure there isn't anything embar..
                                                <Link to="mailto:no-reply@domain.com" className="text-decoration-underline">no-reply@domain.com</Link></p>
                                        </CardMaintenance>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default PagesMaintenance;
